<template>
  <div>
    <v-row
      v-for="permission in availablePermissions"
      :key="permission.code_name"
      dense
      align="center"
      class="mb-1"
    >
      <v-col cols="auto">
        <v-checkbox
          :input-value="value"
          @change="handleChange"
          :value="permission.code_name"
          :label="permission.name"
          dense
          hide-details
        ></v-checkbox>
      </v-col>
      <v-col cols="auto">
        <v-btn
          text
          x-small
          color="teal"
          @click="$emit('open-page', permission.code_name)"
        >
          <v-icon x-small left>mdi-open-in-new</v-icon>
          開啟分頁
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
/**
 * AccountPermissionSelector - 可重用的權限選擇器組件
 *
 * 用途：
 * 1. 新增帳號時選擇權限
 * 2. 編輯帳號權限
 *
 * Props:
 * - value: 已選擇的權限代碼陣列（v-model）
 * - availablePermissions: 可用的權限列表
 *
 * Events:
 * - input: 選擇變更時觸發（v-model）
 * - open-page: 點擊「開啟分頁」時觸發
 */
export default {
  name: 'AccountPermissionSelector',
  props: {
    // v-model
    value: {
      type: Array,
      default: () => []
    },
    // 可用權限列表
    availablePermissions: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    handleChange(selectedPermissions) {
      this.$emit('input', selectedPermissions)
    }
  }
}
</script>

<style scoped>
/* 可根據需要添加樣式 */
</style>
